<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('Destination') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12">
        <div class="d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-arrow-left" data-v-02c2cbc4="">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <router-link class="text-primary" tag="a" :to="{ name: 'DestinationList' }">{{ $t('Back') }}</router-link>
        </div>
      </div>
    </div>
    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <form @submit.prevent="actionForm">
              <div class="row mb-4">
                <div class="col-12">
                  <input id="pac-input" class="controls" type="text" :placeholder="$t('Search Location')" />
                  <div id="map"></div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">{{ $t('Latitude') }}</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control" v-model="formData.latitude"
                    :class="[hasFormError.latitude ? (hasFormError.location ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Latitude')"
                    @blur="destinationStore.removeErrorFormSingle('latitude')" readonly />
                  <div v-if="hasFormError.latitude" class="text-danger fw-bold">{{ hasFormError.latitude }}</div>
                </div>
                <label class="col-sm-2 col-form-label col-form-label-sm">{{ $t('Longitude') }}</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control" v-model="formData.longitude"
                    :class="[hasFormError.longitude ? (hasFormError.location ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Longitude')"
                    @blur="destinationStore.removeErrorFormSingle('longitude')" readonly />
                  <div v-if="hasFormError.longitude" class="text-danger fw-bold">{{ hasFormError.longitude }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Destination Name') }}
                </label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="formData.name"
                    :class="[hasFormError.name ? (hasFormError.name ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Destination Name')"
                    @blur="destinationStore.removeErrorFormSingle('name')" />
                  <div v-if="hasFormError.name" class="invalid-feedback">{{ hasFormError.name }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Destination Type') }}
                </label>
                <div class="col-sm-4">
                  <select class="form-select" v-model="formData.dest_type_id"
                    :class="[hasFormError.dest_type_id ? (hasFormError.dest_type_id ? 'is-invalid' : '') : '']"
                    @blur="destinationStore.removeErrorFormSingle('dest_type_id')">
                    <option value="">{{ $t('Select') + ' ' + $t('Destination Type') }}</option>
                    <option v-for="item in listDestinationType" :value="item.dest_type_id">
                      {{ item.name }}
                    </option>
                  </select>
                  <div v-if="hasFormError.dest_type_id" class="invalid-feedback">{{ hasFormError.dest_type_id }}</div>
                </div>
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('District') }}
                </label>
                <div class="col-sm-4">
                  <select class="form-select" v-model="formData.district_id"
                    :class="[hasFormError.district_id ? (hasFormError.district_id ? 'is-invalid' : '') : '']"
                    @blur="destinationStore.removeErrorFormSingle('district_id')">
                    <option value="">{{ $t('Select') + ' ' + $t('District') }}</option>
                    <option v-for="item in listDistrict" :value="item.district_id">
                      {{ item.name }}
                    </option>
                  </select>
                  <div v-if="hasFormError.district_id" class="invalid-feedback">{{ hasFormError.district_id }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Address') }}
                </label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="formData.address"
                    :class="[hasFormError.address ? (hasFormError.address ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Address')"
                    @blur="destinationStore.removeErrorFormSingle('address')" />
                  <div v-if="hasFormError.address" class="invalid-feedback">{{ hasFormError.address }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Description') }}
                </label>
                <div class="col-sm-10">
                  <textarea type="text" class="form-control" v-model="formData.desc"
                    :class="[hasFormError.desc ? (hasFormError.desc ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Description')" rows="5"
                    @blur="destinationStore.removeErrorFormSingle('desc')" />
                  <div v-if="hasFormError.desc" class="invalid-feedback">{{ hasFormError.desc }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="title">{{ $t('Priority') }}</label>
                <div class="col-sm-10">
                  <div class="checkbox-primary custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" value="1" id="chk1"
                      v-model="formData.is_superior" />
                    <label class="custom-control-label" for="chk1">
                      {{ $t('Choose as a top tourist destination') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Facility') }}
                </label>
                <div class="col-sm-10">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="formData.facility"
                      :class="[hasFormError.facility ? (hasFormError.facility ? 'is-invalid' : '') : '']"
                      :placeholder="$t('Enter') + ' ' + $t('Facility')"
                      @blur="destinationStore.removeErrorFormSingle('facility')" />
                    <button v-if="action !== 'view'" class="btn btn-primary" @click="addFacility()" type="button">
                      {{ $t('Add') }}
                    </button>
                  </div>
                  <div v-if="hasFormError.facility" class="text-danger fw-bold">{{ hasFormError.facility }}</div>

                  <template v-if="formData.list_facility.length > 0">
                    <div class="table-responsive mt-3">
                      <table role="table" aria-busy="false" aria-colcount="5" class="table table-hover table-bordered"
                        id="__BVID__415">
                        <thead role="rowgroup">
                          <tr role="row">
                            <th v-if="action !== 'view'" role="columnheader" class="text-center" width="40px">
                              {{ $t('Delete') }}
                            </th>
                            <th role="columnheader" class="text-center">
                              <div>{{ $t('Facility') }}</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody role="rowgroup">
                          <tr v-for="(value, key) in formData.list_facility" :key="key" role="row">
                            <td v-if="action !== 'view'" aria-colindex="5" role="cell" class="text-center">
                              <a @click="deleteFacility(key)" href="javascript:void(0)" data-bs-toggle="tooltip">
                                <i class="fas fa-trash text-danger"></i>
                              </a>
                            </td>
                            <td aria-colindex="1" role="cell">{{ value }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Label') }}
                </label>
                <div class="col-sm-10 select2">
                  <multiselect v-model="formData.list_label" :options="listLabel" :multiple="true" :taggable="true"
                    :searchable="true" :placeholder="$t('Search Label')" selected-label="" select-label=""
                    track-by="label" label="label" deselect-label="" @tag="addLabel" @keyup="searchLabel">
                  </multiselect>
                  <!-- <input type="text" class="form-control" v-model="formData.name"
                    :class="[hasFormError.name ? (hasFormError.name ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Destination Name')"
                    @blur="destinationStore.removeErrorFormSingle('name')" /> -->
                  <div v-if="hasFormError.list_label" class="invalid-feedback">{{ hasFormError.list_label }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Upload Main Image') }}
                </label>
                <div class="col-sm-10">
                  <div class="custom-file mb-3">
                    <input id="ufile" type="file" class="custom-file-input" @change="uploadMainImage" />
                    <label for="ufile" data-browse="Browse" class="custom-file-label">
                      <span class="d-block form-file-text">{{ $t('Choose File') }}</span>
                    </label>
                  </div>

                  <ul class="list-group list-group-media mt-4" v-if="formData.main_image">
                    <li class="list-group-item list-group-item-action">
                      <div class="media mb-0">
                        <div class="me-3">
                          <img :src="formData.main_image_collect.file_url" class="img-fluid" style="height:30rem;" />
                        </div>
                        <div class="media-body d-flex align-items-center">
                          <h6 class="tx-inverse">
                            {{ formData.main_image_collect.file_name }}
                            (<span class="tx-success">{{ formData.main_image_collect.file_size }}</span>)
                          </h6>
                          <a v-if="action !== 'view'" href="javascript:void(0)" @click="deleteMainImage"
                            class="text-danger fw-bold mb-2 ms-3">
                            {{ $t('Delete') }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="title">
                  {{ $t('Upload Gallery Image') }}
                </label>
                <div class="col-sm-10">
                  <div class="custom-file mb-3">
                    <input id="ufile2" type="file" class="custom-file-input" @change="uploadGalleryImage" multiple />
                    <label for="ufile2" data-browse="Browse" class="custom-file-label">
                      <span class="d-block form-file-text">{{ $t('Choose File') }}</span>
                    </label>
                  </div>

                  <ul class="list-group list-group-media mt-4" v-if="formData.list_media_collect">
                    <li class="list-group-item list-group-item-action" v-for="item in formData.list_media_collect"
                      :key="item.file_id">
                      <div class="media mb-0">
                        <div class="me-3">
                          <img :src="item.file_url" class="img-fluid rounded-circle"
                            style="height:10rem;width:10rem;" />
                        </div>
                        <div class=" media-body d-flex align-items-center">
                          <h6 class="tx-inverse">
                            {{ item.file_name }}
                            (<span class="tx-success">{{ item.file_size }}</span>)
                          </h6>
                          <a v-if="action !== 'view'" href="javascript:void(0)"
                            @click="deleteGalleryImage(item.file_id)" class="text-danger fw-bold mb-2 ms-3">
                            {{ $t('Delete') }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="row">
                <template v-if="hasErrorSingle">
                  <div class="col-12">
                    <div class="alert alert-light-danger alert-dismissible border-0 mb-4" role="alert">
                      <strong>{{ $t('Failed') }}</strong> {{ hasErrorSingle }}
                      <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
                    </div>
                  </div>
                </template>
                <div class="col-12 col-md-4 offset-md-8">
                  <template v-if="action == 'view'">
                  </template>
                  <template v-else>
                    <button type="submit" class="btn btn-primary btn-lg" :disabled="isLoadingForm">
                      <span v-if="isLoadingForm" class="spinner-border text-white me-2 align-self-center loader-sm">
                        Loading...
                      </span>
                      {{ $t('Save') }}
                    </button>
                    &nbsp;
                    <button @click="destinationStore.resetForm" type="button" class="btn btn-danger btn-lg">
                      {{ $t('Cancel') }}
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style >
.select2 .multiselect__option--highlight {
  background: #fff;
  color: #4361ee !important;
}

.select2 .multiselect__option--selected {
  background-color: rgba(27, 85, 226, 0.23921568627450981);
  color: #4361ee !important;
  font-weight: normal;
}

.select2 .multiselect__option--disabled {
  background: inherit !important;
}

.select2 .multiselect__tag {
  color: #000;
  background: #e4e4e4;
}

.select2 .multiselect__tag-icon:after {
  color: #000 !important;
}

.select2 .multiselect__tag-icon:focus,
.select2 .multiselect__tag-icon:hover {
  background: inherit;
}
</style>

<script setup>
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useDestinationStore } from '@/store/destination/destinationStore';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useGenDestinationType } from '@/composables/general/gen-destination-type';
import { useGenDistrict } from '@/composables/general/gen-district';
import { useGenLabel } from '@/composables/general/gen-label';

import Multiselect from '@suadelabs/vue3-multiselect';
import '@suadelabs/vue3-multiselect/dist/vue3-multiselect.css';

const { listDestinationType } = useGenDestinationType();
const { listDistrict } = useGenDistrict();

const { t } = useI18n();
const destinationStore = useDestinationStore();
const { formData, hasFormError, isLoadingForm, hasErrorSingle, isSuccess } = storeToRefs(destinationStore);
const route = useRoute();
const router = useRouter()
destinationStore.resetForm();

const idData = ref('');
const action = ref(route.query.act);
const listAction = ['edit', 'view'];

// --------------- start action -----------------------------
const actionForm = async () => {
  if (action.value == 'edit') {
    await destinationStore.updateData(idData.value);
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
      router.push({ name: 'DestinationList' });
    }
  } else if (action.value == 'view') {
    // console.log('view');
  } else {
    await destinationStore.saveData();
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
    }
  }
}
// --------------- end action -----------------------------

// ------------- start facility ---------------------
const addFacility = () => {
  if (formData.value.facility) {
    formData.value.list_facility.push(formData.value.facility);
    formData.value.facility = null;
  } else {
    hasFormError.value.facility = t('Facility is required');
  }
};

const deleteFacility = (index) => {
  formData.value.list_facility.splice(index, 1);
};
// ------------- end facility ---------------------

// ------------------ start multi select -------------------
const { listLabel, getLabel, saveLabel } = useGenLabel();
const addLabel = async (newTag) => {
  await saveLabel(newTag);
  await getLabel();
};
const searchLabel = async (e) => {
  await getLabel(e.target.value);
};
// ------------------ end multi select -------------------

// ------------- start upload main image ---------------------
const uploadMainImage = async (e) => {
  const file = e.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'IMAGE');
    console.log('uploadMainImage', formData);
    await destinationStore.uploadFile(formData, 'MAIN_IMAGE');
  }
}
const deleteMainImage = () => {
  formData.value.main_image = null;
  formData.value.main_image_collect = null;
}
// ------------- end upload main image ---------------------

// ------------- start upload gallery image ---------------------
const uploadGalleryImage = async (e) => {
  const files = e.target.files;
  if (files) {
    for (let i = 0; i < files.length; i++) {
      const formData = new FormData();
      formData.append('file', files[i]);
      formData.append('type', 'IMAGE');
      await destinationStore.uploadFile(formData, 'GALLERY_IMAGE');
    }
  }
}
const deleteGalleryImage = (id) => {
  formData.value.list_media = formData.value.list_media.filter(item => item != id);
  formData.value.list_media_collect = formData.value.list_media_collect.filter(item => item.file_id != id);
}
// ------------- end upload gallery image ---------------------

// ------------- start google map ---------------------
onMounted(async () => {
  function initMap() {
    const map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: -6.5829085894835675, lng: 110.67247223101933 },
      zoom: 13,
    });

    const drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.MARKER,
        ],
      },
    });
    drawingManager.setMap(map);

    // Create the search box and link it to the UI element.
    const input = document.getElementById("pac-input");
    const searchBox = new google.maps.places.SearchBox(input);

    map.controls[google.maps.ControlPosition.TOP_CENTER].push(input);
    // Bias the SearchBox results towards current map's viewport.
    map.addListener("bounds_changed", () => {
      searchBox.setBounds(map.getBounds());
    });

    let markers = [];

    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();

      if (places.length == 0) {
        return;
      }

      // Clear out the old markers.
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];

      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds();

      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          console.log("Returned place contains no geometry");
          return;
        }

        const icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };

        // Create a marker for each place.
        markers.push(
          new google.maps.Marker({
            map,
            icon,
            title: place.name,
            position: place.geometry.location,
          })
        );
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      map.fitBounds(bounds);
    });

    // add marker to map when click
    google.maps.event.addListener(drawingManager,
      'markercomplete', function (marker) {
        // clear all marker
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers.push(marker);

        // set lat and lng to formData
        hasFormError.value.latitude = null;
        hasFormError.value.longitude = null;

        formData.value.latitude = marker.position.lat();
        formData.value.longitude = marker.position.lng();
      });

    if (listAction.includes(route.query.act)) {
      if (formData.value.latitude && formData.value.longitude) {
        // set marker to map
        const marker = new google.maps.Marker({
          position: { lat: parseFloat(formData.value.latitude), lng: parseFloat(formData.value.longitude) },
          map,
        });

        // clear all marker
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers.push(marker);
      }
    }
  }

  if (listAction.includes(route.query.act)) {
    idData.value = route.query.id;
    await destinationStore.getDataDetail(idData.value);
  }

  initMap();
});
// ------------- end google map ---------------------
</script>

<style scoped>
.ql-container.ql-snow {
  height: 500px;
  overflow-y: auto;
}

/* MAP */
#map {
  height: 400px;
  width: 100%;
}

#description {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
}

#infowindow-content .title {
  font-weight: bold;
}

#infowindow-content {
  display: none;
}

#map #infowindow-content {
  display: inline;
}

.pac-card {
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
  margin: 10px;
  padding: 0 0.5em;
  font: 400 18px Roboto, Arial, sans-serif;
  overflow: hidden;
  font-family: Roboto;
  padding: 0;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}

#pac-input:focus {
  border-color: #4d90fe;
}

#title {
  color: #fff;
  background-color: #4d90fe;
  font-size: 25px;
  font-weight: 500;
  padding: 6px 12px;
}

#target {
  width: 345px;
}
</style>
